<template>
  <div class="content">
    <!-- Nagłówek z przyciskiem rozwijania/zwinania filtrów -->
    <!-- <h2
      data-bs-toggle="collapse"
      :href="`#archival-filters`"
      role="button"
      aria-expanded="true"
      :aria-controls="`archival-filters`"
      @click="clickFilters"
      class="margin-0"
      v-if="filtersStore.step < 3"
    >
      {{ t('filters').toUpperCase() }}
    </h2> -->

    <div v-if="filtersStore.step < 4" class="d-flex justify-content-between actions-down">
      <!-- Przycisk powrotu (widoczny jeśli nie jesteśmy na 1 kroku) -->
      <button class="btn-prev" v-if="filtersStore.step > 1" @click="previousStep()">
        {{ t('back2').toUpperCase() }}
      </button>
      <!-- Przycisk "dalej"/"zastosuj" (widoczny jeśli nie jesteśmy na ostatnim kroku) -->
      <button class="btn-next ms-auto" v-if="filtersStore.step < 4" @click="nextStep()" :disabled="!canGoNext">
        {{ filtersStore.step < 3 ? t('next').toUpperCase() : t('apply').toUpperCase() }}
      </button>
    </div>

    <!-- Sekcja filtrów, widoczna jeśli nie ukryta -->
    <div
      class="collapse"
      :class="hideFilters ? '' : 'show'"
      :id="`archival-filters`"
    >
      <!-- Krok 1: Filtr lokalizacji i zakresu dat -->
      <div v-if="filtersStore.step == 1">
        <div class="d-flex step-content step1">
          <location-list :store="filtersStore" cssClass="archival" />
          <date-range :store="filtersStore" />
        </div>
      </div>

      <!-- Krok 2: Filtry naruszeń, kategorii pojazdów, pasów, dane pojazdu -->
      <div class="d-flex step-content step2 flex-wrap" v-else-if="filtersStore.step == 2 && !isSG">
        <violation-list :store="filtersStore" />
        <vehicle-categories :store="filtersStore" :step="filtersStore.step" />
        <lane-numbers :store="filtersStore" :step="filtersStore.step" />
        <div class="break"></div>
        <archival-vehicle-data />
      </div>

      <div class="d-flex step-content step2 flex-wrap" v-else-if="filtersStore.step == 2 && isSG">
        <archival-vehicle-data />
      </div>

      <!-- Krok 3: Sortowanie (do trzech poziomów) -->
      <div class="step-content step3 sort-panel" v-else-if="filtersStore.step == 3">
        <div class="sort-panel__row" v-for="n in (isSG ? 2 : 3)" :key="n">
          <select-filter
            class="sort-panel__control"
            :name="t('type')"
            :fieldName="`orderByColumnName${n}`"
            type="column"
            :store="filtersStore"
            :step="step"
          />
          <select-filter
            class="sort-panel__control"
            :name="t('direction')"
            :fieldName="`orderDirection${n}`"
            type="direction"
            :store="filtersStore"
            :step="step"
          />
        </div>
      </div>

      <!-- Nawigacja kroków: wstecz/dalej -->
<!--      <div v-if="filtersStore.step < 4" class="d-flex justify-content-between actions-down">-->
<!--        <button class="btn-prev" v-if="filtersStore.step > 1" @click="previousStep()">-->
<!--          {{ t('back2').toUpperCase() }}-->
<!--        </button>-->
<!--        <button class="btn-next ms-auto" v-if="filtersStore.step < 4" @click="nextStep()">-->
<!--          {{ step === 3 ? t('apply').toUpperCase() : t('next').toUpperCase() }}-->
<!--        </button>-->
<!--      </div>-->
    </div>

    <!-- Krok 4: Wyniki + eksport + paginacja -->
    <div v-if="filtersStore.step === 4" class="content">
      <h3 class="d-flex">
        <div class="d-flex justify-content-between actions btn-top me-auto">
          <!-- Przycisk powrotu do filtrów -->
          <button class="btn-prev-top" @click="previousStep()">{{ t('back2').toUpperCase() }}</button>
        </div>
        <div class="d-flex total-count">
          <!-- Liczba wyników -->
          <span>
            Ilość wyników: {{ totalCount }}
          </span>
        </div>

        <!-- Eksport PDF -->
        <div class="dropdown-wrapper" @click="toggleDropdown('pdf')">
<!--          <button class="btn" :disabled="noData">-->
          <button class="btn">
            <span>PDF</span>
          </button>
          <ul v-show="isOpenPdf" class="dropdown-list">
            <li @click.stop="selectOption('pdf')">
              <span v-show="isDownloadingPdf" class="spinner-border spinner-border-sm me-1"></span>
              PDF
            </li>
            <li @click.stop="selectOption('pdf-with-image')">
              <span v-show="isDownloadingPdfWithImage" class="spinner-border spinner-border-sm me-1"></span>
              PDF {{ t('with-image') }}
            </li>
          </ul>
        </div>

        <!-- Eksport CSV -->
        <div class="dropdown-wrapper" @click="toggleDropdown('csv')">
<!--          <button class="btn" :disabled="noData">-->
          <button class="btn">
            <span>CSV</span>
          </button>
          <ul v-show="isOpenCsv" class="dropdown-list">
            <li @click.stop="selectOption('csv')">
              <span v-show="isDownloadingCsv" class="spinner-border spinner-border-sm me-1"></span>
              CSV
            </li>
            <li @click.stop="selectOption('csv-with-image')">
              <span v-show="isDownloadingCsvWithImage" class="spinner-border spinner-border-sm me-1"></span>
              CSV {{ t('with-image') }}
            </li>
          </ul>
        </div>

        <!-- Eksport XLSX -->
        <div class="dropdown-wrapper" @click="toggleDropdown('xlsx')">
<!--          <button class="btn" :disabled="noData">-->
          <button class="btn">
            <span>XLSX</span>
          </button>
          <ul v-show="isOpenXlsx" class="dropdown-list">
            <li @click.stop="selectOption('xlsx')">
              <span v-show="isDownloadingXlsx" class="spinner-border spinner-border-sm me-1"></span>
              XLSX
            </li>
            <li @click.stop="selectOption('xlsx-with-image')">
              <span v-show="isDownloadingXlsxWithImage" class="spinner-border spinner-border-sm me-1"></span>
              XLSX {{ t('with-image') }}
            </li>
          </ul>
        </div>
      </h3>
      <!-- Loader -->
      <spinner-element :loading="loading" />
      <!-- Komunikat gdy brak danych -->
      <div v-if="noData" class="loading d-flex justify-content-center m-3">
        {{ t('no-data-for-selected-parameters') }}
      </div>
      <!-- Lista wyników -->
      <vehicle-list
        :data-service="vehService"
        :vehicle-list="filtersStore.savedVehicles && filtersStore.savedVehicles.length > 0 ? filtersStore.savedVehicles : vehicles"
        :timer-visible="false"
        details-path="vehicleArch"
        :is-from-tags="isFromTags"
        @openDetails="goToDetailsView"
      />
      <!-- Paginacja -->
      <PagePanel
        :page-num="pageNumber"
        :page-size="pageSize"
        :total-size="totalCount"
        v-on:setPage="setPage"
      />
      <!-- <div class="d-flex justify-content-between actions-down">
        <button class="btn-prev" @click="previousStep()">{{ t('back2').toUpperCase() }}</button>
      </div> -->
    </div>
  </div>
</template>

<script>
// Importujemy wszystkie zależności, filtry i komponenty
import { useArchivalFiltersStore } from "../stores/archivalFilters";
import ArchivalMeasurementsService from "../services/ArchivalMeasurementsService";
import LocationList from "./filters/LocationList.vue";
import DateRange from "./filters/DateRange.vue";
import LaneNumbers from "./filters/LaneNumbers.vue";
import VehicleCategories from "./filters/VehicleCategories.vue";
import ViolationList from "./filters/ViolationList.vue";
import ArchivalVehicleData from "./archival/ArchivalVehicleData.vue";
import SelectFilter from "./filters/SelectFilter.vue";
import VehicleList from "@/components/VehicleList";
import moment from "moment";
import SpinnerElement from "./SpinnerElement.vue";
import PagePanel from "@/components/table/PagePanel";
import { ref, watch, computed } from 'vue';
import { isSG } from "@/config/appVersion";
import { useRoute, useRouter } from "vue-router";

moment.locale("pl");

export default {
  // Krok procesu przekazywany jako props
  props: {
    step: { type: Number, required: true }
  },
  components: {
    LocationList,
    DateRange,
    LaneNumbers,
    VehicleCategories,
    ViolationList,
    ArchivalVehicleData,
    SelectFilter,
    VehicleList,
    SpinnerElement,
    PagePanel,
  },
  name: "ArchivalMeasurements",
  emits: ["nextStep", "previousStep", "clear"],

  // Setup API (composition API)
  setup(props, { emit }) {
    const filtersStore = useArchivalFiltersStore();

    // Stan komponentu
    const vehicles = ref([]);
    const loading = ref(false);
    const noData = ref(false);
    const hideFilters = ref(false);

    const vehService = ArchivalMeasurementsService;

    // Stany spinnerów eksportu
    const isDownloadingPdf = ref(false);
    const isDownloadingPdfWithImage = ref(false);
    const isDownloadingCsv = ref(false);
    const isDownloadingCsvWithImage = ref(false);
    const isDownloadingXlsx = ref(false);
    const isDownloadingXlsxWithImage = ref(false);

    // Paginacja
    const pageNumber = ref(1);
    const pageSize = ref(10);
    const totalCount = ref(0);

    // Otwarcie dropdownów eksportu
    const isOpenPdf = ref(false);
    const isOpenCsv = ref(false);
    const isOpenXlsx = ref(false);

    // Czy wyniki są z tagów?
    const isFromTags = ref(false);

    const route = useRoute();
    const router = useRouter();

    // init page from URL
    pageNumber.value = Number(route.query.page || 1);

    // reaguj na zmianę query (np. powrót z details)
    watch(
        () => route.query.page,
        (p) => {
          const newPage = Number(p || 1);
          if (newPage !== pageNumber.value) {
            pageNumber.value = newPage;
            refreshVehicles(); // albo refreshData(), zależnie jak chcesz
          }
        }
    );

    // Funkcja pobierająca dane pojazdów (różne jeśli są tagi)
    // const refreshVehicles = async () => {
    //   loading.value = true;
    //   noData.value = false;
    //   vehicles.value = [];
    //
    //   try {
    //     let data;
    //
    //     // Pobierz pojazdy z API lub tylko te z tagami
    //     if (!filtersStore.filters.taggedOnly) {
    //       data = await vehService.getAll(pageNumber.value, pageSize.value);
    //       isFromTags.value = false;
    //     } else {
    //       data = await vehService.getAllWithTags();
    //       isFromTags.value = true;
    //     }
    //
    //     // Ustal liczbę wyników
    //     if (data.content && data.content.length) {
    //       vehicles.value = data.content;
    //       totalCount.value = data.totalCount ?? data.content.length;
    //       noData.value = false;
    //     } else {
    //       noData.value = true;
    //     }
    //   } catch (e) {
    //     filtersStore.setErrors(e);
    //     noData.value = true;
    //   } finally {
    //     loading.value = false;
    //   }
    // };
    const refreshVehicles = async () => {
      loading.value = true;
      noData.value = false;

      console.log('refreshVehicles');

      try {
        let data;

        if (!filtersStore.filters.taggedOnly) {
          data = await vehService.getAll(pageNumber.value, pageSize.value);
          isFromTags.value = false;
        } else {
          data = await vehService.getAllWithTags();
          isFromTags.value = true;
        }

        // --- Ujednolicenie odpowiedzi ---
        // 1) TAGI: czasem API zwraca tablicę
        if (Array.isArray(data)) {
          vehicles.value = data;
          totalCount.value = data.length;
          noData.value = data.length === 0;
          return;
        }

        const items = data?.content ?? data?.items ?? [];
        const total =
            data?.totalCount ??
            data?.totalElements ??   // bardzo częste w paginacji
            data?.total ??           // fallback
            (Array.isArray(items) ? items.length : 0);

        totalCount.value = Number(total) || 0;
        vehicles.value = Array.isArray(items) ? items : [];

        // totalPages (jeśli backend nie zwraca)
        const totalPages =
            data?.totalPages ??
            (pageSize.value > 0 ? Math.ceil(totalCount.value / pageSize.value) : 0);

        // --- Jeśli jesteś poza zakresem stron, cofnij i pobierz ponownie ---
        if (totalPages > 0 && pageNumber.value > totalPages) {
          pageNumber.value = totalPages;

          // sync do URL
          router.replace({
            path: route.path,
            query: { ...route.query, page: String(pageNumber.value) },
          });

          // ponów pobranie już dla poprawnej strony
          const data2 = await vehService.getAll(pageNumber.value, pageSize.value);

          const items2 = data2?.content ?? data2?.items ?? [];
          const total2 =
              data2?.totalCount ??
              data2?.totalElements ??
              data2?.total ??
              (Array.isArray(items2) ? items2.length : 0);

          totalCount.value = Number(total2) || 0;
          vehicles.value = Array.isArray(items2) ? items2 : [];
        }

        noData.value = totalCount.value === 0;
      } catch (e) {
        filtersStore.setErrors(e);
        vehicles.value = [];
        totalCount.value = 0;
        noData.value = true;
      } finally {
        loading.value = false;
      }
    };

    const canGoNext = computed(() => {
      // blokada tylko na kroku 1
      if (filtersStore.step !== 1) return true;

      const locs = filtersStore.filters?.locations;
      return Array.isArray(locs) && locs.length > 0;
    });


    // Nasłuch na zmianę kroku procesu (główna logika)
    // const lastNonResultStep = ref(filtersStore.step);
    // watch(() => filtersStore.step, (newStep) => {
    //   // if (newStep < 4) lastNonResultStep.value = newStep;
    //   if (newStep === 4) {
    //     // Jeśli zapisano pojazdy, nie pobieraj na nowo
    //     if (filtersStore.savedVehicles && filtersStore.savedVehicles.length > 0) {
    //       vehicles.value = [...filtersStore.savedVehicles];
    //       noData.value = vehicles.value.length === 0;
    //       loading.value = false;
    //     } else {
    //       refreshVehicles();
    //     }
    //   }
    // }, { immediate: true });
    watch(
        () => filtersStore.step,
        (newStep) => {
          // ✅ jeśli nie jesteśmy w wynikach, usuń page z URL
          if (newStep !== 4 && route.query.page) {
            router.replace({ path: route.path, query: {} });
          }

          if (newStep === 4) {
            // Jeśli zapisano pojazdy, nie pobieraj na nowo
            if (filtersStore.savedVehicles && filtersStore.savedVehicles.length > 0) {
              vehicles.value = [...filtersStore.savedVehicles];
              noData.value = vehicles.value.length === 0;
              loading.value = false;
            } else {
              refreshVehicles();
            }
          }
        },
        { immediate: true }
    );

    // Reload na żądanie (np. po zmianie filtrów)
    // watch(() => filtersStore.shouldReload, (val) => {
    //   if (val) {
    //     filtersStore.setShouldReload(false);
    //     refreshVehicles();
    //   }
    // });
    // watch(
    //     () => filtersStore.shouldReload,
    //     (val) => {
    //       if (val) {
    //         filtersStore.setShouldReload(false);
    //         refreshVehicles();
    //       }
    //     },
    //     { immediate: true } // <-- KLUCZ
    // );
    watch(
        () => filtersStore.shouldReload,
        (val) => {
          if (!val) return;

          filtersStore.setShouldReload(false);

          // odświeżaj tylko gdy jesteś w wynikach
          if (filtersStore.step === 4) {
            pageNumber.value = 1;

            // usuń page z URL (żeby nie było /archival?page=30)
            if (route.query.page) {
              router.replace({ path: route.path, query: {} });
            }

            refreshVehicles();
          }
        },
        { immediate: true }
    );

    // Odśwież na wejście w widok wyników
    watch(() => filtersStore.isResult, (val) => {
      if (val) {
        refreshVehicles();
      }
    });

    // Zmiana filtrów powoduje pokazanie formularza i wyczyszczenie wyników
    // watch(() => filtersStore.filters, () => {
    //   hideFilters.value = false;
    //   vehicles.value = [];
    // }, { deep: true });
    watch(
        () => filtersStore.filters,
        () => {
          hideFilters.value = false;
          vehicles.value = [];
          totalCount.value = 0;
          noData.value = false;
        },
        { deep: true }
    );

    // Przejście do kolejnego kroku
    // const nextStep = () => {
    //   const newStep = filtersStore.step + 1;
    //   filtersStore.setStep(newStep);
    //   if (newStep >= 4) filtersStore.setIsResult(true);
    //   emit('nextStep');
    // };
    //
    // // Powrót do poprzedniego kroku
    // const previousStep = () => {
    //   const newStep = filtersStore.step - 1;
    //   filtersStore.setStep(newStep);
    //   emit('previousStep');
    // };

    // const nextStep = () => {
    //   const newStep = Math.min(4, filtersStore.step + 1);
    //   filtersStore.setStep(newStep);
    //   console.log("nextStep");
    //   console.log(filtersStore.step);
    //   filtersStore.setIsResult(newStep >= 4); // wyniki tylko dla kroku 4
    //   emit('nextStep');
    // };

    const nextStep = () => {
      if (!canGoNext.value) return;

      const newStep = Math.min(4, filtersStore.step + 1);
      filtersStore.setStep(newStep);
      filtersStore.setIsResult(newStep >= 4);
      emit('nextStep');
    };


    // const previousStep = () => {
    //   // jeśli jesteś w wynikach (4) – wróć do kroku, z którego tu wszedłeś
    //   if (filtersStore.step === 4) {
    //     // filtersStore.setStep(lastNonResultStep.value);
    //     const target = filtersStore.lastStepBeforeResults || 3; // fallback
    //     filtersStore.setStep(target);
    //     filtersStore.setIsResult(false);     // wychodzisz z wyników
    //     hideFilters.value = false;
    //   } else {
    //     const newStep = Math.max(1, filtersStore.step - 1);
    //     filtersStore.setStep(newStep);
    //   }
    //   emit('previousStep');
    // };
    const previousStep = () => {
      if (filtersStore.step === 4) {
        const target = filtersStore.lastStepBeforeResults || 3;
        filtersStore.setStep(target);
        filtersStore.setIsResult(false);
        hideFilters.value = false;

        // ✅ usuń page z URL
        router.replace({ path: "/archival", query: {} });
      } else {
        const newStep = Math.max(1, filtersStore.step - 1);
        filtersStore.setStep(newStep);
      }

      emit("previousStep");
    };

    // Wyczyszczenie widoku i reset filtrów
    const clear = () => {
      emit('clear');
      hideFilters.value = false;
    };

    // const shouldHideLocation = computed(() => {
    //   const version = process.env.VUE_APP_VERSION_NAME || "";
    //   return version.startsWith("SG");
    // });

    // Zwracamy wszystko co potrzebne w template
    return {
      filtersStore,
      vehicles,
      loading,
      noData,
      hideFilters,
      nextStep,
      previousStep,
      clear,
      refreshVehicles,
      vehService,
      isDownloadingPdf,
      isDownloadingPdfWithImage,
      isDownloadingCsv,
      isDownloadingCsvWithImage,
      isDownloadingXlsx,
      isDownloadingXlsxWithImage,
      pageNumber,
      pageSize,
      totalCount,
      isOpenPdf,
      isOpenCsv,
      isOpenXlsx,
      isFromTags,
      isSG,
      canGoNext,
      route,
      router
    };
  },

  // Reszta funkcji (options API)
  methods: {
    // Odśwież dane na podstawie aktualnych filtrów
    refreshData: function () {
      this.hideFilters = true;
      this.refreshVehicles();
    },
    // Otwieranie dropdownów eksportu
    toggleDropdown(type) {
      // if (this.noData) return;
      this.isOpenPdf = type === 'pdf' ? !this.isOpenPdf : false;
      this.isOpenCsv = type === 'csv' ? !this.isOpenCsv : false;
      this.isOpenXlsx = type === 'xlsx' ? !this.isOpenXlsx : false;
    },
    // Obsługa kliknięcia eksportu
    selectOption(type) {
      if (type == 'pdf') {
        this.isDownloadingPdf = true;
      }
      if (type == 'pdf-with-image') {
        this.isDownloadingPdfWithImage = true;
      }
      if (type == 'csv') {
        this.isDownloadingCsv = true;
      }
      if (type == 'csv-with-image') {
        this.isDownloadingCsvWithImage = true;
      }
      if (type == 'xlsx') {
        this.isDownloadingXlsx = true;
      }
      if (type == 'xlsx-with-image') {
        this.isDownloadingXlsxWithImage = true;
      }
      // Pobierz plik w odpowiednim formacie
      if (!this.isFromTags) {
        this.retrieveZip(type);
      } else {
        this.retrieveTagsZip(type);
      }
    },
    // Główna funkcja pobierania archiwalnych pojazdów (nieużywana)
    retrieveArchivalMeasurements() {
      this.loading = true;
      this.refreshData();
    },
    // Ustaw spinner (ładowanie) na podstawie wyników
    setLoading: function () {
      this.loading = this.vehicles.length === 0;
    },
    // Reakcja na zmianę lokalizacji
    runChangedLocations(locations) {
      if (!this.isResult) return;
      if (!locations || locations.length === 0) {
        this.filtersStore.checkRequireData();
        this.clear();
      } else {
        this.refreshVehicles();
      }
    },
    // Reakcja na zmianę filtrów
    runChangedFilters() {
      if (!this.isResult) return;
      this.filtersStore.checkRequireData();
      this.hideFilters = false;
      this.vehicles = [];
    },
    // Zmiana strony w paginacji
    // setPage(event) {
    //   this.pageNumber = event;
    //   this.refreshData();
    // },
    setPage(event) {
      this.pageNumber = event;

      // zapis do URL (żeby powrót działał)
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, page: String(event) },
      });

      this.refreshData();
    },
    // Obsługa spinnerów eksportu
    downloadingIcon(type, value) {
      if (type === "pdf") {
        this.isDownloadingPdf = value;
      }
      if (type === "pdf-with-image") {
        this.isDownloadingPdfWithImage = value;
      }
      if (type === "csv") {
        this.isDownloadingCsv = value;
      }
      if (type === "csv-with-image") {
        this.isDownloadingCsvWithImage = value;
      }
      if (type === "xlsx") {
        this.isDownloadingXlsx = value;
      }
      if (type === "xlsx-with-image") {
        this.isDownloadingXlsxWithImage = value;
      }
    },
    // Pobieranie ZIP z API (standard)
    retrieveZip(type) {
      this.downloadingIcon(type, true);
      this.vehService
        .getZip(type)
        .then((data) => {
          this.vehService
            .fetch(data.link)
            .then((response) => {
              const link = document.createElement("a");
              link.href = URL.createObjectURL(response);
              // Nazwa pliku na podstawie daty
              const now = new Date();
              const year = now.getFullYear();
              const month = String(now.getMonth() + 1).padStart(2, '0');
              const day = String(now.getDate()).padStart(2, '0');
              const hours = String(now.getHours()).padStart(2, '0');
              const minutes = String(now.getMinutes()).padStart(2, '0');
              const seconds = String(now.getSeconds()).padStart(2, '0');
              const fileName = `archive_list_${day}_${month}_${year}_${hours}_${minutes}_${seconds}`;
              link.download = fileName;
              link.click();
              this.downloadingIcon(type, false);
              URL.revokeObjectURL(link.href);
            })
            .catch(console.error)
            .finally(() => {
              this.downloadingIcon(type, false);
              this.closeDropdown(type);
            });
        })
        .catch((error) => {
          this.loading = false;
          this.filtersStore.setErrors(error);
          this.closeDropdown(type);
        });
    },
    // Pobieranie ZIP z API (dla wyników z tagami)
    retrieveTagsZip(type) {
      this.downloadingIcon(type, true);
      this.vehService
        .getTagsZip(type)
        .then((data) => {
          this.vehService
            .fetch(data.link)
            .then((response) => {
              const link = document.createElement("a");
              link.href = URL.createObjectURL(response);
              const now = new Date();
              const year = now.getFullYear();
              const month = String(now.getMonth() + 1).padStart(2, '0');
              const day = String(now.getDate()).padStart(2, '0');
              const hours = String(now.getHours()).padStart(2, '0');
              const minutes = String(now.getMinutes()).padStart(2, '0');
              const seconds = String(now.getSeconds()).padStart(2, '0');
              const fileName = `archive_list_${day}_${month}_${year}_${hours}_${minutes}_${seconds}`;
              link.download = fileName;
              link.click();
              URL.revokeObjectURL(link.href);
            })
            .catch(console.error)
            .finally(() => {
              this.downloadingIcon(type, false);
              this.closeDropdown(type);
            });
        })
        .catch((error) => {
          this.loading = false;
          this.filtersStore.setErrors(error);
          this.closeDropdown(type);
        });
    },
    // Otwieranie/ukrywanie filtrów po kliknięciu
    clickFilters(event) {
      if (event.target.className !== "collapsed") {
        this.hideFilters = false;
      }
    },
    // Przejście do widoku szczegółowego pojazdu (do routera)
    goToDetailsView(vehicle) {
      this.filtersStore.setSavedState(
        this.filtersStore.filters.locations,
        this.filtersStore.filters,
        this.vehicles
      );
      // const path = `/vehicleArch/${vehicle.id}/${vehicle.location.id}/${this.getCreatedAt(vehicle)}`;
      // this.$router.push({ path });
      const path = `/vehicleArch/${vehicle.id}/${vehicle.location.id}/${this.getCreatedAt(vehicle)}`;
      // this.$router.push({ path, query: { step: String(this.filtersStore.lastStepBeforeResults || 3) } });
      const query = { page: String(this.pageNumber) };
      this.$router.push({ path, query });
    },
    // Pobierz datę utworzenia pojazdu w ISO
    getCreatedAt(vehicle) {
      return moment(vehicle.createdAt).toISOString(false);
    },
    // Zamknięcie dropdowna eksportu po pobraniu
    closeDropdown(type) {
      if (type === 'pdf' || type === 'pdf-with-image') {
        this.isOpenPdf = false;
      } else if (type === 'csv' || type === 'csv-with-image') {
        this.isOpenCsv = false;
      } else if (type === 'xlsx' || type === 'xlsx-with-image') {
        this.isOpenXlsx = false;
      }
    },
  },
};
</script>

<style scoped>
.dropdown-wrapper {
  position: relative;
  display: inline-block;
}

.dropdown-wrapper .btn {
  margin-top: 5px;
  margin-left: 10px;
  background-color: #e0e0e0;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
}

.dropdown-wrapper .btn span {
  margin-right: 10px;
}

.dropdown-list {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ccc;
  width: 180px;
  z-index: 10;
  text-align: center;
}

.dropdown-list li {
  padding: 8px 4px;
  cursor: pointer;
  text-align: center;
  font-size: 14px;
}

.dropdown-list li:hover {
  background: #f0f0f0;
}

.content,
.step-content {
  width: 100%;
  min-height: 478px;
}

.content h2 {
  position: relative;
  /* margin: 0; */
  padding: 15px 20px;
  background-color: white;
  cursor: pointer;
}

.content h2::after {
  width: 22px;
  height: 18px;
  position: absolute;
  left: 100px;
  top: 20px;
  content: "";
  background: url("../assets/icons/filtry.png") no-repeat left top;
}

.step1 {
  width: 100%;
  /* background: #f5f4f2 url("../assets/a-bg.png") repeat-x left top; */
}

.step2 .violations {
  width: 285px;
  border-top: 1px solid #bfbfbf;
}

.step2 .vehicle-categories .category-table {
  background-color: red;
}

h3 {
  position: relative;
  padding: 10px 20px;
  background-color: white;
  border-top: 1px solid #b8b8b6;
  margin-bottom: 0;
}

/* h3 span {
  align-content: center;
  align-items: center;
} */

h3 button {
  position: relative;
  padding: 5px 15px 5px 25px;
  margin-right: 10px;
}

/* h3 button::before { */
  /* position: absolute;
  left: 5px;
  top: 5px;
  content: "";
  width: 30px;
  height: 20px; */
  /* background: url("../assets/icons/pobierz.png") no-repeat left top; */
/* } */

.sort {
  margin-top: 1rem;
}

.actions {
  background-color: #f5f4f2;
}

.actions button {
  border: 0;
  font-size: 19px;
  font-weight: bold;
  background: none;
}

.actions .btn-prev {
  margin-left: 30px;
  padding: 8px 8px 8px 45px;
  position: relative;
  color: #58585a;
}

.actions .btn-prev:before {
  content: "";
  position: absolute;
  left: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/powrot.png") no-repeat left top;
}

.actions .btn-prev:hover {
  color: black;
}

.actions .btn-prev:hover:before {
  background: url("../assets/icons/powrot_over.png") no-repeat left top;
}

.actions .btn-next {
  margin-right: 50px;
  padding: 8px 40px 8px 8px;
  /* border: 2px solid #58585a; */
  position: relative;
  color: #58585a;
}

.actions .btn-next:before {
  content: "";
  position: absolute;
  right: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/dalej.png") no-repeat left top;
}

.actions .btn-next:hover {
  color: black;
}

.actions .btn-next:hover:before {
  background: url("../assets/icons/dalej_over.png") no-repeat left top;
}

.btn-top {
  background-color: white;
}

.actions .btn-prev-top {
  margin-left: 10px;
  padding: 8px 8px 8px 45px;
  position: relative;
  color: #58585a;
  background-color: white;
}

.actions .btn-prev-top:before {
  content: "";
  position: absolute;
  left: 0;
  top: 9px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/powrot.png") no-repeat left top;
}

.actions-down {
  background-color: white;
  min-height: 43px;
}

.actions-down button {
  border: 0;
  font-size: 19px;
  font-weight: bold;
  background: none;
}

.actions-down .btn-next {
  margin-right: 50px;
  padding: 8px 40px 8px 8px;
  position: relative;
  color: #58585a;
}

.actions-down .btn-next:before {
  content: "";
  position: absolute;
  right: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/dalej.png") no-repeat left top;
}

.actions-down .btn-next:hover {
  color: black;
}

.actions-down .btn-next:hover:before {
  background: url("../assets/icons/dalej_over.png") no-repeat left top;
}

.actions-down .btn-prev {
  margin-left: 30px;
  padding: 0 0 0 40px;
  position: relative;
  color: #58585a;
}

.actions-down .btn-prev:before {
  content: "";
  position: absolute;
  left: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/powrot.png") no-repeat left top;
}

.actions-down .btn-prev:hover {
  color: black;
}

.actions-down .btn-prev:hover:before {
  background: url("../assets/icons/powrot_over.png") no-repeat left top;
}

.total-count {
  margin-right: 170px;
  margin-top: 8px;
  font-size: 17px;
}

/* .filter .name {
  font-size: 20px !important;
} */

/* Panel sortowania – spójny z poprzednim krokiem (mniejsza czcionka, karty) */
.sort-panel {
  --fz: 14px;          /* dopasuj do kroku 2, np. 14px */
  --gap: 12px;
  --pad: 12px;
  --radius: 10px;
  --bd: #e5e7eb;       /* neutral-200 */
  --label: #6b7280;    /* gray-500 */
  font-size: var(--fz);
  display: grid;
  gap: var(--gap);
}

/* Każdy poziom sortowania jako kompaktowa karta */
.sort-panel__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--gap);
  padding: var(--pad);
  border: 1px solid var(--bd);
  border-radius: var(--radius);
  background: #fff;
}

/* Responsywność: na wąskich ekranach pod sobą */
@media (max-width: 900px) {
  .sort-panel__row {
    grid-template-columns: 1fr;
  }
}

/* Ujednolicenie wyglądu wnętrza select-filter (bez modyfikacji komponentu) */
:deep(.sort-panel__control) {
  font-size: inherit;             /* odziedzicza 14px */
}

/* Jeśli w środku jest <label> – zrób je subtelne i zwarte */
:deep(.sort-panel__control label) {
  display: block;
  margin: 0 0 4px 0;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: .01em;
  color: var(--label);
}

/* Jeśli w środku jest <select> lub element robiący za selecta – wyrównaj wysokość */
:deep(.sort-panel__control select),
:deep(.sort-panel__control .select),
:deep(.sort-panel__control .vs__dropdown-toggle),
:deep(.sort-panel__control .v-select .vs__selected-options) {
  min-height: 36px;               /* kompaktowa wysokość */
  line-height: 36px;
  border-radius: 8px;
}

/* Opcjonalnie: usuń nadmierne marginesy wokół kontrolki wewnątrz select-filter */
:deep(.sort-panel__control .field),
:deep(.sort-panel__control .wrapper) {
  margin: 0;
}
</style>
